import { render, staticRenderFns } from "./reserveConfirmList.vue?vue&type=template&id=2b9b5189&scoped=true"
import script from "./reserveConfirmList.vue?vue&type=script&lang=js"
export * from "./reserveConfirmList.vue?vue&type=script&lang=js"
import style0 from "./reserveConfirmList.vue?vue&type=style&index=0&id=2b9b5189&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9b5189",
  null
  
)

export default component.exports